import Vue from "vue";
import Vuex from "vuex";
import batchModule from "@/store/modules/batch";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {},
  mutations: {},
  actions: {},
  modules: {
    batch: batchModule
  }
});
